import { VariableType } from 'json-to-graphql-query';

export const ProfileVariables = {
  profile: 'ProfileInput!'
};

export const ProfileArgs = {
  profile: new VariableType('profile')
};
